/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ellipses_Replacement_CompleteInputs */

const en_ellipses_replacement_complete = /** @type {(inputs: Ellipses_Replacement_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ellipses replacement complete`)
};

const fr_ellipses_replacement_complete = /** @type {(inputs: Ellipses_Replacement_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacement par les points de suspension terminé`)
};

const de_ellipses_replacement_complete = /** @type {(inputs: Ellipses_Replacement_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ellipsenaustausch komplett`)
};

const it_ellipses_replacement_complete = /** @type {(inputs: Ellipses_Replacement_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituzione ellissi completata`)
};

const ru_ellipses_replacement_complete = /** @type {(inputs: Ellipses_Replacement_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полная замена эллипсов`)
};

const es_ellipses_replacement_complete = /** @type {(inputs: Ellipses_Replacement_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazo de elipses completo`)
};

const zh_cn2_ellipses_replacement_complete = /** @type {(inputs: Ellipses_Replacement_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`椭圆替换完成`)
};

const ja_ellipses_replacement_complete = /** @type {(inputs: Ellipses_Replacement_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`楕円の置き換えが完了しました`)
};

const hi_ellipses_replacement_complete = /** @type {(inputs: Ellipses_Replacement_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दीर्घवृत्त प्रतिस्थापन पूर्ण`)
};

const pt_pt2_ellipses_replacement_complete = /** @type {(inputs: Ellipses_Replacement_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substituição das elipses concluída`)
};

/**
* | output |
* | --- |
* | "Ellipses replacement complete" |
*
* @param {Ellipses_Replacement_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ellipses_replacement_complete = /** @type {((inputs?: Ellipses_Replacement_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ellipses_Replacement_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ellipses_replacement_complete(inputs)
	if (locale === "de") return de_ellipses_replacement_complete(inputs)
	if (locale === "it") return it_ellipses_replacement_complete(inputs)
	if (locale === "ru") return ru_ellipses_replacement_complete(inputs)
	if (locale === "es") return es_ellipses_replacement_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_ellipses_replacement_complete(inputs)
	if (locale === "ja") return ja_ellipses_replacement_complete(inputs)
	if (locale === "hi") return hi_ellipses_replacement_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_ellipses_replacement_complete(inputs)
	return en_ellipses_replacement_complete(inputs)
});